import { render } from "./SubstitutionsForm.vue?vue&type=template&id=23ee1e08&ts=true"
import script from "./SubstitutionsForm.vue?vue&type=script&lang=ts"
export * from "./SubstitutionsForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__